<div class="connected-terms-of-service-container-wrapper">
  <div class="connected-terms-of-service-container" *ngIf="text">
    <div class="connected-terms-of-service-body" [innerHtml]="text">
    </div>
  </div>
</div>